import createReactComponent from '../createReactComponent';
var Haze = createReactComponent('Haze', [['path', {
  d: 'M5.2 6.2l1.4 1.4',
  key: '9nbp7c'
}], ['path', {
  d: 'M2 13h2',
  key: '13gyu8'
}], ['path', {
  d: 'M20 13h2',
  key: '16rner'
}], ['path', {
  d: 'M17.4 7.6l1.4-1.4',
  key: '1c68dr'
}], ['path', {
  d: 'M22 17H2',
  key: '1gtaj3'
}], ['path', {
  d: 'M22 21H2',
  key: '1gy6en'
}], ['path', {
  d: 'M16 13a4 4 0 00-8 0',
  key: '15ze47'
}], ['path', {
  d: 'M12 5V2.5',
  key: '1vytko'
}]]);
export default Haze;